"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridlist = require("@react-aria/gridlist");
var _focus = require("@react-aria/focus");
var _list = require("@react-stately/list");
var _collections = require("@react-stately/collections");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _SelectionList = require("./SelectionList.styled");
var _InnerButton = require("../buttons/InnerButton");
var _Icon = require("../../media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var StyledContent = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__StyledContent",
  componentId: "sc-1yhvc68-0"
})(["", ";border-color:", ";height:inherit;flex:1;"], _SelectionList.selectionListCss, _tokens.default.sky.sys.color.border.decorative);
var ListItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__ListItemWrapper",
  componentId: "sc-1yhvc68-1"
})(["border-radius:", ";background:", ";"], function (_ref) {
  var opened = _ref.opened;
  return opened && _tokens.default.sky.sys.size.borderradius['2'];
}, function (_ref2) {
  var opened = _ref2.opened;
  return opened && _tokens.default.sky.sys.color.background.primary['1'];
});
var RowContainer = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__RowContainer",
  componentId: "sc-1yhvc68-2"
})(["display:flex;flex-direction:row;> :not(:first-child){border-left:none;border-bottom-left-radius:0;border-top-left-radius:0;}> :not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;}"]);
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__IconWrapper",
  componentId: "sc-1yhvc68-3"
})(["cursor:pointer;padding:12px;"]);
var StyledItem = _styledComponents.default.div.withConfig({
  displayName: "SelectionList__StyledItem",
  componentId: "sc-1yhvc68-4"
})(["", ""], _SelectionList.selectableItemCss);
var StyledIcon = function StyledIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread({}, props))
  });
};
var ListItem = function ListItem(_ref3) {
  var item = _ref3.item,
    state = _ref3.state;
  var ref = _react.default.useRef(null);
  var _ref7 = (0, _gridlist.useGridListItem)({
      node: item
    }, state, ref),
    rowProps = _ref7.rowProps,
    gridCellProps = _ref7.gridCellProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, rowProps, {
      ref: ref,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledItem, _objectSpread({}, gridCellProps, {
        "data-cy": item.props['data-cy'],
        children: item.rendered
      }))
    }))
  });
};
var OpenNestedOptionIcon = function OpenNestedOptionIcon(_ref4) {
  var onClick = _ref4.onClick,
    dataCy = _ref4['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.NonVisualButton, {
    "data-cy": dataCy,
    "aria-label": 'Open nested options',
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
      icon: 'chevronRight',
      size: 'm'
    })
  });
};
var ShowHideIcon = function ShowHideIcon(_ref5) {
  var onClick = _ref5.onClick,
    checked = _ref5.checked,
    dataCy = _ref5['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.NonVisualButton, {
    "data-cy": dataCy,
    "aria-label": 'Toggle show/hide',
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
      icon: checked ? 'view' : 'hide',
      size: 'm'
    })
  });
};
var SelectionList = function SelectionList(_ref6) {
  var openedOptions = _ref6.openedOptions,
    ariaProps = _objectWithoutProperties(_ref6, ["openedOptions"]);
  var state = (0, _list.useListState)(ariaProps);
  var items = (0, _react.useMemo)(function () {
    return _toConsumableArray(state.collection);
  }, [state.collection]);
  var ref = (0, _react.useRef)(null);
  var _ref8 = (0, _gridlist.useGridList)(ariaProps, state, ref),
    gridProps = _ref8.gridProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, _objectSpread({}, gridProps, {
    ref: ref,
    children: items.map(function (item) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ListItemWrapper, {
        opened: openedOptions === null || openedOptions === void 0 ? void 0 : openedOptions.includes(item.key.toString()),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ListItem, {
          item: item,
          state: state
        }, item.key)
      });
    })
  }));
};
SelectionList.RowContainer = RowContainer;
SelectionList.Item = _collections.Item;
SelectionList.OpenNestedOptionIcon = OpenNestedOptionIcon;
SelectionList.ShowHideIcon = ShowHideIcon;
var _default = exports.default = SelectionList;